import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, FormGroup, Modal, ModalBody } from "reactstrap";
import SvgImage from "../../Icons/Icons";
import { Formik } from "formik";
import * as Yup from "yup";
import { fetchBalance } from "../../../services/Store/Actions/manageCardActions";
import { getCardDetails } from "../../../services/Store/Actions/LogipeCardActions";
import { ClipLoader } from "react-spinners";
import BackgroundIMG from "../../../assets/images/yesbank2.png";

const validationSchema = Yup.object().shape({
  amount: Yup.string()
    .required("Required")
    .matches(/^[0-9]$/, "amount must be a number"),
});
function YesbankCard(props) {
  const {
    open,
    onHide,
    toggleModal,
    handleClose,
    vendorData,
    onSubmit,
    mode,
    setMode,
    remarks,
  } = props;
  const { driverDetails, driverCardStatus, userId } = props;
  // const status = driverCardStatus===4||7?true:false;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCardDetails(userId));
  }, [userId]);

  const {cardDetails,cardDetailsLoader} = useSelector((state) => state?.driverlist);
  // const cardDetailsLoader = useSelector((state) => state?.cardDetails?.loader);

  const expiryDate =
    cardDetails?.details?.expiryDate == null
      ? "NA"
      : cardDetails?.details?.expiryDate;

  const cardNumber =
    cardDetails?.details?.cardNumber == null
      ? "NA"
      : cardDetails?.details?.cardNumber;
  const correctCard =
    cardNumber === "NA"
      ? "NA"
      : cardNumber.substring(0, 4) +
        "-" +
        cardNumber.substring(4, 8) +
        "-" +
        cardNumber.substring(8, 12) +
        "-" +
        cardNumber.substring(12, 16);

  console.log("Card Details ff *****", driverCardStatus, userId, cardDetails);

  // const [open, setOpen]= useState(false);

  // const handleClose=()=>{
  //     setOpen(false);
  // }

  // const toggleModal=()=>{
  //     setOpen(!open);
  // }

  // const showModal=()=>{
  //     setOpen(true);
  // }
  return (
    <Modal
      isOpen={open}
      onHide={onHide}
      toggle={toggleModal}
      className="Card-Modal settingModalMargin"
      aria-labelledby="myModalLabel2"
    >
      {/* <div
        className="closeRemove"
        onClick={() => {
          // Router.reload();
          handleClose();
        }}
      >
        <SvgImage name="CloseButtonLogo" />
      </div> */}
      <>
        <div
          style={{
            backgroundImage: `url(${BackgroundIMG})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            width: "574px",
            height: "100vh",
          }}
        >
          <div style={{ margin: "92px 0 0 28px" }}>
            <div className="row">
              {/* <div className="col-10 cardNameDr Medium heading3 padding16T">
              {driverDetails?.length > 30
                ? driverDetails?.split(0, 30) + "..."
                : driverDetails}
            </div> */}
              {/* <div
              className="col-2 padding16T"
              style={{ cursor: "pointer" }}
              //   onClick={showModal}
            >
              <SvgImage name="cardSettingOpt" />
            </div> */}
            </div>
            <div className="whiteText Medium heading3 padding24T padding16B">
              {cardDetailsLoader ? (
                <ClipLoader
                  color={"#485B7C"}
                  loading={cardDetailsLoader}
                  size={20}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) : (
                correctCard
              )}
            </div>
            <div
              className="row padding32B"
              style={{
                marginTop: "46px",
              }}
            >
              <div className="col-4">
                <div className="col-10 cardNameDr Medium heading3 padding16T">
                  {driverDetails?.length > 30
                    ? driverDetails?.split(0, 30) + "..."
                    : driverDetails}
                </div>
                {/* <div className="cardNameDr text4">Expiry Date</div>
              <div className="whiteText Medium heading3">
                {cardDetailsLoader ? (
                  <ClipLoader
                    color={"#485B7C"}
                    loading={cardDetailsLoader}
                    size={20}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                ) : (
                  expiryDate
                )}
              </div> */}
              </div>
              <div className="offset-4 col-4" style={{ textAlign: "center" }}>
                <div className="cardNameDr text4">Expiry Date</div>
                <div className="whiteText Medium heading3">
                  {cardDetailsLoader ? (
                    <ClipLoader
                      color={"#485B7C"}
                      loading={cardDetailsLoader}
                      size={20}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : (
                    expiryDate
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "0",
                right: "0",
                zIndex: "300",
              }}
            >
              <SvgImage name="titledRect1" />
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "0",
                right: "0",
                zIndex: "300",
              }}
            >
              <SvgImage name="titledRect2" />
            </div>
          </div>
        </div>

        {/* <img src={require("../../../assets/images/yesbank.png")} /> */}
        {/* <div className="cardContainerNew" style={{ position: "relative",        width: "400px",
        height: "200px" }}>
          <div className="row">
            <div className="col-10 cardNameDr Medium heading3 padding16T">
              {driverDetails?.length > 30
                ? driverDetails?.split(0, 30) + "..."
                : driverDetails}
            </div>
            <div
              className="col-2 padding16T"
              style={{ cursor: "pointer" }}
            //   onClick={showModal}
            >
              <SvgImage name="cardSettingOpt" />
            </div>
          </div>
          <div className="whiteText Medium heading3 padding24T padding16B">
            {cardDetailsLoader ? (
              <ClipLoader
                color={"#485B7C"}
                loading={cardDetailsLoader}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            ) : (
              correctCard
            )}
          </div>
          <div className="row padding32B">
            <div className="col-4">
              <div className="cardNameDr text4">Expiry Date</div>
              <div className="whiteText Medium heading3">
                {cardDetailsLoader ? (
                  <ClipLoader
                    color={"#485B7C"}
                    loading={cardDetailsLoader}
                    size={20}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                ) : (
                  expiryDate
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="cardNameDr text4">CVV</div>
              <div className="whiteText Medium heading3">XXX</div>
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "0",
              right: "0",
              zIndex: "300",
            }}
          >
            <SvgImage name="titledRect1" />
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "0",
              right: "0",
              zIndex: "300",
            }}
          >
            <SvgImage name="titledRect2" />
          </div>
        </div> */}
        {/* {
         <CardControlsModal
           userId={userId}
           open={open}
           toggleModal={toggleModal}
           title="Logipe Account"
           handleClose={handleClose}
           cardType={props.cardType}
         />
         } */}
      </>
    </Modal>
  );
}

export default YesbankCard;
